module.exports = __webpack_public_path__ + "static/img/threeLast.5ca66b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/threeLast.png
// module id = KlFp
// module chunks = 1